import moment from 'moment'
import arEG from 'antd/locale/ar_EG'

// The day before or after, counted on the calendar: a day the clocks change on is not 24 hours long, and moment's own
// day arithmetic lands on the hour that does not exist when the clocks go forward at midnight
const shiftDay = (date, days) =>
  moment(
    moment
      .utc(moment(date).format('YYYY-MM-DD'))
      .add(days, 'day')
      .format('YYYY-MM-DD')
  ).startOf('day')

export const handleNextDate = rangeDate => {
  if (rangeDate.length > 1) {
    if (rangeDate[1].diff(rangeDate[0], 'days') > 300) {
      return [moment(rangeDate[0]).add(1, 'year'), moment(rangeDate[1]).add(1, 'year')]
    } else if (rangeDate[1].diff(rangeDate[0], 'days') && rangeDate[1].diff(rangeDate[0], 'hours') > 25) {
      if (rangeDate[1].diff(rangeDate[0], 'days') === 6) {
        return [moment(rangeDate[0]).add(1, 'week'), moment(rangeDate[1]).add(1, 'week')]
      } else {
        return [
          moment(rangeDate[0]).add(1, 'month'),
          moment(rangeDate[1])
            .add(1, 'month')
            .endOf('month')
        ]
      }
    } else {
      const start = shiftDay(rangeDate[0], 1)
      const end = moment(start).endOf('day')
      return [start, end]
    }
  } else {
    return [
      moment()
        .startOf('month')
        .add(1, 'month'),
      moment()
        .endOf('month')
        .add(1, 'month')
    ]
  }
}

export const handlePrevDate = rangeDate => {
  if (rangeDate.length > 1) {
    if (rangeDate[1].diff(rangeDate[0], 'days') > 300) {
      return [moment(rangeDate[0]).subtract(1, 'year'), moment(rangeDate[1]).subtract(1, 'year')]
    } else if (rangeDate[1].diff(rangeDate[0], 'days') && rangeDate[1].diff(rangeDate[0], 'hours') > 25) {
      if (rangeDate[1].diff(rangeDate[0], 'days') === 6) {
        return [moment(rangeDate[0]).subtract(1, 'week'), moment(rangeDate[1]).subtract(1, 'week')]
      } else {
        return [
          moment(rangeDate[0]).subtract(1, 'month'),
          moment(rangeDate[1])
            .subtract(1, 'month')
            .endOf('month')
        ]
      }
    } else {
      const start = shiftDay(rangeDate[0], -1)
      const end = moment(start).endOf('day')
      return [start, end]
    }
  } else {
    return [
      moment()
        .subtract(1, 'month')
        .startOf('month'),
      moment()
        .subtract(1, 'month')
        .endOf('month')
    ]
  }
}

export const datePickerArabicShortDaysFix = language =>
  language === 'ar' && arEG?.DatePicker?.lang
    ? {
        ...arEG.DatePicker,
        lang: {
          ...arEG.DatePicker.lang,
          shortWeekDays: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
          shortMonths: [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر'
          ]
        }
      }
    : undefined

/**
 * Whether a dashboard range is within the days back and forward of today the clinic lets users kept to one day go
 * (none set: any day), as the server holds them to it
 */
export const isWithinDashboardDays = (rangeDate, extraSettings) => {
  const { dashboardDaysBack, dashboardDaysForward } = extraSettings || {}
  if (!rangeDate?.length) return true
  if (
    Number.isInteger(dashboardDaysBack) &&
    moment(rangeDate[0]).isBefore(moment().startOf('day').subtract(dashboardDaysBack, 'day'))
  ) {
    return false
  }
  return (
    !Number.isInteger(dashboardDaysForward) ||
    !moment(rangeDate[1]).isAfter(moment().endOf('day').add(dashboardDaysForward, 'day'))
  )
}
